<template>
  <v-container fluid>
    <v-card v-for="machine in machines" class="my-3 pb-n3" :color="machine.color">
        <v-checkbox
            v-model="machine.active"
            :label="machine.name"
            :readonly="readonly"
            class="mt-3"
        >
        </v-checkbox>
      <v-row v-if="machine.active">
        <BaseAttribute v-for="attribute in machine.attributes" :item="attribute" :readonly="readonly"></BaseAttribute>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>

import BaseAttribute from "@/components/Base/BaseAttribute";

export default {
  name: 'MachineAttribute',
  props: {
    machines: {factory: []},
    readonly: {type: [Boolean], default: false},
  },

  components: {
    BaseAttribute,
  },

  computed: {},

  watch: {
    attributes: {
      handler(newValue, oldValue) {
        // console.log('watch')
        this.emitValue()
      },
      deep: true
    }
  },

  methods: {
    emitValue() {
      // console.log('emitValue')
      this.$emit('update:attributes', this.attributes)
    },

    async mounted() {
    }
    ,

    data() {
      return {}
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "new_document": "New document"
  },
  "de": {
    "new_document": "Neues Dokument"
  }
}
</i18n>
